import TitledPage, {TitledPageProps} from "./TitledPage";
import React from "react";
import { Box, Icon } from "@chakra-ui/react";
import {FaArrowLeft} from "react-icons/fa";

export interface NewsPageProps extends TitledPageProps {
    author: string;
    date: string;
}

const NewsPage: React.FC<NewsPageProps> = ({children, date, author, title, ...rest}) => (
    <TitledPage title={<><Icon as={FaArrowLeft} /> {title}</>} {...rest}>
        <Box borderBottomWidth="1px" borderBottomColor="primary.50" borderBottomStyle="solid">
            Posted: {date} by {author}
        </Box>
        {children}
    </TitledPage>
)

export default NewsPage;